
















import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'

@Component({})
export default class SpotifyLogin extends Vue {
  modalOpen: boolean = false
  reAuthenticate: boolean = false

  get show(): boolean {
    return this.modalOpen && !this.authorized
  }

  get authorized(): boolean {
    return this.$store.state.auth.userProps && this.$store.state.auth.userProps.spotifyAuthorized
  }

  close() {
    this.modalOpen = false

    this.removeListener()
  }

  addListener() {
    window.addEventListener('focus', this.onWindowFocus)
  }

  removeListener() {
    window.removeEventListener('focus', this.onWindowFocus)
  }

  async onWindowFocus() {
    if (!this.authorized) {
      await this.$store.dispatch('auth/fetchUserProps')
    }
  }

  async waitForAuth(reAuthenticate: boolean = false) {
    this.modalOpen = true
    this.reAuthenticate = reAuthenticate

    if (!this.authorized) {
      this.addListener()

      await new Promise((resolve) => {
        this.$watch('authorized', resolve)
      })

      this.removeListener()
    }
  }

  async spotifyRedirect() {
    const { data } = await Axios.post('/spotify/authorize')

    const { authorizeUrl } = data

    window.open(authorizeUrl, '_blank')
  }
}
